export const NODE_COLORS = {
    start:      { border: 'border-emerald-500', badgeBg: 'bg-emerald-500', cardBg: '' },
    text:       { border: 'border-sky-500',     badgeBg: 'bg-sky-500',     cardBg: '' },
    image:      { border: 'border-emerald-500', badgeBg: 'bg-emerald-500', cardBg: '' },
    video:      { border: 'border-red-500',     badgeBg: 'bg-red-500',     cardBg: '' },
    audio:      { border: 'border-purple-500',  badgeBg: 'bg-purple-500',  cardBg: '' },
    typing:     { border: 'border-yellow-400',  badgeBg: 'bg-yellow-400',  cardBg: '' },
    input:      { border: 'border-sky-500',     badgeBg: 'bg-sky-500',     cardBg: '' },
    delay:      { border: 'border-yellow-400',  badgeBg: 'bg-yellow-400',  cardBg: '' },
    smart_delay:{ border: 'border-yellow-400',  badgeBg: 'bg-yellow-400',  cardBg: '' },
    condition:  { border: 'border-pink-500',    badgeBg: 'bg-pink-500',    cardBg: '' },
    randomizer: { border: 'border-sky-400',     badgeBg: 'bg-sky-400',     cardBg: '' },
    trigger:    { border: 'border-rose-500',    badgeBg: 'bg-rose-500',    cardBg: '' },
    payment:    { border: 'border-emerald-500', badgeBg: 'bg-emerald-500', cardBg: '' },
    card_payment: { border: 'border-indigo-500', badgeBg: 'bg-indigo-500', cardBg: '' },
    spei_payment: { border: 'border-teal-500', badgeBg: 'bg-teal-500', cardBg: '' },
    upsell:     { border: 'border-emerald-500', badgeBg: 'bg-emerald-500', cardBg: '' },
    downsell:   { border: 'border-red-500',     badgeBg: 'bg-red-500',     cardBg: '' },
    entregavel: { border: 'border-blue-500',    badgeBg: 'bg-blue-500',    cardBg: '' },
    location:   { border: 'border-cyan-500',    badgeBg: 'bg-cyan-500',    cardBg: '' },
    buttons:    { border: 'border-violet-500',  badgeBg: 'bg-violet-500',  cardBg: '' },
    composed:   { border: 'border-violet-500',  badgeBg: 'bg-violet-500',  cardBg: '' },
    goto:       { border: 'border-slate-500',   badgeBg: 'bg-slate-500',   cardBg: '' },
    order_bump: { border: 'border-amber-400',   badgeBg: 'bg-amber-400',   cardBg: '' },
};

export function getNodeIconClass(nodeType) {
    const icons = {
        text:        'fas fa-font',
        image:       'fas fa-image',
        video:       'fas fa-video',
        audio:       'fas fa-microphone',
        typing:      'fas fa-keyboard',
        input:       'fas fa-keyboard',
        delay:       'fas fa-clock',
        smart_delay: 'fas fa-hourglass-half',
        payment:     'fas fa-credit-card',
        card_payment: 'fas fa-money-check-dollar',
        spei_payment: 'fas fa-building-columns',
        condition:   'fas fa-code-branch',
        randomizer:  'fas fa-random',
        trigger:     'fas fa-bolt',
        button:      'fas fa-square',
        location:    'fas fa-map-marker-alt',
        composed:    'fas fa-layer-group',
        goto:        'fas fa-arrow-right',
        upsell:      'fas fa-arrow-up',
        downsell:    'fas fa-arrow-down',
        order_bump:  'fas fa-gift',
    };
    return icons[nodeType] ?? 'fas fa-comments';
}

export function getTypeLabel(type) {
    const labels = {
        start:       'Início',
        text:        'Texto',
        image:       'Imagem',
        video:       'Vídeo',
        audio:       'Áudio',
        typing:      'Digitando...',
        input:       'Input do usuário',
        delay:       'Atraso',
        smart_delay: 'Atraso humanizado',
        payment:     'Gerar PIX',
        card_payment: 'Gerar pagamento cartão',
        spei_payment: 'Gerar pagamento SPEI',
        condition:   'Condição',
        randomizer:  'Randomizador',
        trigger:     'Gatilho',
        upsell:      'Upsell',
        downsell:    'Downsell',
        entregavel:  'Entregável',
        location:    'Localização',
        buttons:     'Botões',
        composed:    'Mensagem Composta',
        goto:        'Go To',
        order_bump:  'Order Bump',
    };
    return labels[type] ?? 'Bloco';
}

export function getNodeSelectLabel(n, index) {
    const type = n.data?.nodeType || n.data?.type || 'text';
    const d = n.data || {};
    const sfx = index != null ? ` #${index}` : '';

    const trunc = (str, len = 22) => {
        if (!str) return '';
        const s = String(str).replace(/\n/g, ' ').trim();
        return s.length > len ? s.slice(0, len) + '…' : s;
    };
    const unitShort = (u) => ({ seconds: 's', minutes: 'min', hours: 'h', days: 'd' })[u] || u;

    switch (type) {
        case 'delay':
            return `${sfx}⏱️ Atraso${d.delayValue ? ` - ${d.delayValue}${unitShort(d.delayUnit)}` : ''}`;
        case 'smart_delay':
            return `${sfx}⏱️ Atraso${d.smartDelayMin ? ` - ${d.smartDelayMin}~${d.smartDelayMax}${unitShort(d.smartDelayUnit)}` : ' humanizado'}`;
        case 'typing':
            return `${sfx}💬 Digitando`;
        case 'payment': {
            const amtNum = parseFloat(d.paymentAmount);
            const amt = !isNaN(amtNum) && amtNum > 0 ? `R$ ${amtNum.toFixed(2).replace('.', ',')}` : '';
            const plan = d.paymentPlanName ? trunc(d.paymentPlanName, 15) : '';
            const detail = [amt, plan].filter(Boolean).join(' - ');
            return `${sfx}💳 PIX${detail ? ` - ${detail}` : ''}`;
        }
        case 'card_payment': {
            const amtNum = parseFloat(d.paymentAmount);
            const amt = !isNaN(amtNum) && amtNum > 0 ? `US$ ${amtNum.toFixed(2)}` : '';
            const plan = d.paymentPlanName ? trunc(d.paymentPlanName, 15) : '';
            const detail = [amt, plan].filter(Boolean).join(' - ');
            return `${sfx}💳 Cartão${detail ? ` - ${detail}` : ''}`;
        }
        case 'spei_payment': {
            const amtNum = parseFloat(d.paymentAmount);
            const amt = !isNaN(amtNum) && amtNum > 0 ? `MX$ ${amtNum.toFixed(2)}` : '';
            const plan = d.paymentPlanName ? trunc(d.paymentPlanName, 15) : '';
            const detail = [amt, plan].filter(Boolean).join(' - ');
            return `${sfx}🏦 SPEI${detail ? ` - ${detail}` : ''}`;
        }
        case 'buttons': {
            const items = d.buttonItems || [];
            const names = items.map((b) => trunc(b.text, 12)).filter(Boolean).join(', ');
            return `${sfx}🔘 ${items.length > 1 ? 'Botões' : 'Botão'}${names ? ` - ${names}` : ''}`;
        }
        case 'button':
            return `${sfx}🔘 Botão${d.text ? ` - ${trunc(d.text)}` : ''}`;
        case 'condition':
            return `${sfx}🔀 Condição${d.conditionVar ? ` - ${trunc(d.conditionVar, 18)}` : ''}`;
        case 'randomizer':
            return `${sfx}🎲 Randomizador`;
        case 'input':
            return `${sfx}⌨️ Input${d.inputVar ? ` - {{${d.inputVar}}}` : ''}`;
        case 'trigger':
            return `${sfx}⚡ Gatilho`;
        case 'goto':
            return `${sfx}🎯 Go To`;
        case 'entregavel':
            return `${sfx}📦 Entregável`;
        case 'upsell':
            return `${sfx}📈 Upsell`;
        case 'downsell':
            return `${sfx}📉 Downsell`;
        case 'composed':
            return `${sfx}📝 Msg. Composta${d.composedElements?.length ? ` (${d.composedElements.length} blocos)` : ''}`;
        case 'image':
            return `${sfx}🖼️ Imagem${d.media?.fileName ? ` - ${trunc(d.media.fileName, 18)}` : d.text ? ` - ${trunc(d.text, 18)}` : ''}`;
        case 'video':
            return `${sfx}🎬 Vídeo${d.media?.fileName ? ` - ${trunc(d.media.fileName, 18)}` : d.text ? ` - ${trunc(d.text, 18)}` : ''}`;
        case 'audio':
            return `${sfx}🎵 Áudio${d.media?.fileName ? ` - ${trunc(d.media.fileName, 18)}` : ''}`;
        case 'order_bump': {
            const priceNum = parseFloat(d.orderBumpPrice);
            const price = !isNaN(priceNum) && priceNum > 0 ? `R$ ${priceNum.toFixed(2).replace('.', ',')}` : '';
            const bumpName = d.orderBumpName ? trunc(d.orderBumpName, 15) : '';
            const detail = [price, bumpName].filter(Boolean).join(' - ');
            return `${sfx}🎁 Order Bump${detail ? ` - ${detail}` : ''}`;
        }
        case 'text':
        default:
            return `${sfx}📝 Mensagem${d.text ? ` - ${trunc(d.text)}` : ''}`;
    }
}
